import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/close.svg'
import _imports_1 from '@/assets/icons/icon-plus.svg'


const _hoisted_1 = { class: "gallery-wr admin-builder-house" }
const _hoisted_2 = { class: "input-row" }
const _hoisted_3 = { class: "input-wr w-100" }
const _hoisted_4 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_5 = { class: "input-row" }
const _hoisted_6 = { class: "input-wr w-50" }
const _hoisted_7 = ["value", "onChange"]
const _hoisted_8 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_9 = { class: "input-wr w-50" }
const _hoisted_10 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_11 = { class: "image-wr facades" }
const _hoisted_12 = {
  key: 0,
  class: "image-remove-wr"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 1,
  class: "upload-image-wr mb-3"
}
const _hoisted_15 = { class: "upload-image-button-wr bigger" }
const _hoisted_16 = {
  key: 0,
  class: "spinner spinner-small"
}
const _hoisted_17 = { class: "input-row" }
const _hoisted_18 = { class: "input-wr w-50" }
const _hoisted_19 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_20 = { class: "controls" }
const _hoisted_21 = {
  key: 1,
  class: "spinner spinner-small"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["ModalWithHeader"], {
      isOpen: $props.isOpen,
      maxWidth: true,
      onClose: $setup.close
    }, {
      title: _withCtx(() => [...(_cache[8] || (_cache[8] = [
        _createElementVNode("span", { class: "text-semi-bold" }, "Add Facade", -1)
      ]))]),
      description: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("form", {
            class: "default-form",
            onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  placeholder: "Facade Name",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.name) = $event))
                }, null, 512), [
                  [_vModelText, $setup.form.name]
                ]),
                ($setup.v$.name.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($setup.v$.name.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("input", {
                  class: "input",
                  placeholder: "Price",
                  value: $setup.form?.price ? $setup.formatPriceTrim($setup.form?.price) : undefined,
                  onChange: (e) => $setup.updatePriceInput(e)
                }, null, 40, _hoisted_7),
                ($setup.v$.price.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString($setup.v$.price.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode($setup["DropDown"], null, {
                  control: _withCtx(() => [
                    _createElementVNode("button", {
                      class: _normalizeClass(["input dropdown-input", { 'input--error': $setup.v$.storeys.$error }]),
                      type: "button"
                    }, _toDisplayString($setup.form.storeys || "Storeys"), 3),
                    ($setup.v$.storeys.$error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($setup.v$.storeys.$errors[0].$message), 1))
                      : _createCommentVNode("", true)
                  ]),
                  dropdown: _withCtx(() => [
                    _createElementVNode("ul", null, [
                      (_openBlock(), _createElementBlock("li", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.form.storeys = 1)),
                        class: _normalizeClass({ 'dropdown__item-active': $setup.form.storeys === 1 }),
                        key: _ctx.storeys
                      }, "1", 2)),
                      (_openBlock(), _createElementBlock("li", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.form.storeys = 2)),
                        class: _normalizeClass({ 'dropdown__item-active': $setup.form.storeys === 2 }),
                        key: _ctx.storeys
                      }, "2", 2))
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              ($setup.form.url)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    ($setup.form.url)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "remove-image",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.form.url = ''))
                        }, [...(_cache[9] || (_cache[9] = [
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: "close"
                          }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    _createElementVNode("img", {
                      class: "facade-upload",
                      src: $setup.form.url
                    }, null, 8, _hoisted_13)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("label", {
                        class: _normalizeClass(["upload-image-button", { disabled: $setup.isUploadingImage }]),
                        for: 'file-upload'
                      }, [
                        _cache[10] || (_cache[10] = _createElementVNode("img", {
                          src: _imports_1,
                          alt: "uploadImage"
                        }, null, -1)),
                        _cache[11] || (_cache[11] = _createElementVNode("p", null, "Upload image", -1)),
                        ($setup.isUploadingImage)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _cache[12] || (_cache[12] = _createElementVNode("input", { class: "input hidden" }, null, -1)),
                        ($setup.v$.url.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString($setup.v$.url.$errors[0].$message), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
            ]),
            _createElementVNode("input", {
              class: "input-file-upload-image hidden",
              id: 'file-upload',
              type: "file",
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($event.target.value = '')),
              onChange: _cache[5] || (_cache[5] = ($event: any) => ($setup.onUploadImage($event))),
              accept: "image/*"
            }, null, 32)
          ], 32),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              class: "button p-2 cancel",
              onClick: $setup.close
            }, "Cancel"),
            (!$setup.isLoading)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "button p-2 primary mr-0",
                  onClick: $setup.confirm
                }, "Confirm"))
              : (_openBlock(), _createElementBlock("div", _hoisted_21))
          ])
        ])
      ]),
      _: 1
    }, 8, ["isOpen"]),
    _createVNode($setup["ImageCropperModal"], {
      isOpen: $setup.isCropperModalOpen,
      image: $setup.imageToUpload.data,
      onOnCropImage: $setup.onCropImage,
      onClose: _cache[7] || (_cache[7] = ($event: any) => ($setup.isCropperModalOpen = false))
    }, null, 8, ["isOpen", "image"])
  ], 64))
}